import React from 'react'

import ExpandablePanel from '../controls/ExpandablePanel'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { controlHasError } from '../../lib/errorHandler'

class Siedziba extends React.Component {
  state = {
    wojewodztwa: [
      'DOLNOŚLĄSKIE',
      'KUJAWSKO-POMORSKIE',
      'LUBELSKIE',
      'LUBUSKIE',
      'ŁÓDZKIE',
      'MAŁOPOLSKIE',
      'MAZOWIECKIE',
      'OPOLSKIE',
      'PODKARPACKIE',
      'PODLASKIE',
      'POMORSKIE',
      'ŚLĄSKIE',
      'ŚWIĘTOKRZYSKIE',
      'WARMIŃSKO-MAZURSKIE',
      'WIELKOPOLSKIE',
      'ZACHODNIOPOMORSKIE',
    ],
  }

  render() {
    return (
      <ExpandablePanel title="SIEDZIBA">
        <form autoComplete="off" className="siedziba">
          <div className="firstRow">
            <FormControl component="fieldset">
              <InputLabel>Województwo</InputLabel>
              <Select
                error={controlHasError(this.props.errors, 'Wojewodztwo')}
                name="Wojewodztwo"
                value={this.props.data.Wojewodztwo}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              >
                {this.state.wojewodztwa.map(w => (
                  <MenuItem value={w} key={w}>
                    {w.toLocaleLowerCase()}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl component="fieldset">
              <TextField
                error={controlHasError(
                  this.props.errors,
                  'Powiat',
                  this.props.data.Powiat,
                )}
                name="Powiat"
                label="Powiat"
                title={this.props.data.Powiat}
                value={this.props.data.Powiat}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>
            <FormControl component="fieldset">
              <TextField
                error={controlHasError(
                  this.props.errors,
                  'Gmina',
                  this.props.data.Gmina,
                )}
                name="Gmina"
                label="Gmina"
                title={this.props.data.Gmina}
                value={this.props.data.Gmina}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>
          </div>
          <FormControl component="fieldset" className="miejscowosc">
            <TextField
              error={controlHasError(
                this.props.errors,
                'Miejscowosc',
                this.props.data.Miejscowosc,
              )}
              name="Miejscowosc"
              label="Miejscowość"
              title={this.props.data.Miejscowosc}
              value={this.props.data.Miejscowosc}
              onChange={e =>
                this.props.onSetSectionData(e.target.name, e.target.value)
              }
            />
          </FormControl>
        </form>
      </ExpandablePanel>
    )
  }
}

export default Siedziba
